import { adminHttpClient } from "../commons/adminHttpClient";

const deleteBannedActivity = (id: string): Promise<any> => {
  return adminHttpClient.delete(`/BannedActivities/Delete`, {
    data: { id: id }
  });
};

export default deleteBannedActivity;
